import { useState } from 'react';
import {saveEquipment} from "../../services/Administrative/equipmentService";

export const useSaveEquipment = () => {
    const [savingNewEquipment, setSavingNewEquipment] = useState(false);

    const saveNewEquipment = async (equipmentDTO: any) => {
        setSavingNewEquipment(true);
        try {
            const response:any = await saveEquipment(equipmentDTO);
            return response.data.data.equipment;
        } catch (error: any) {
            throw error.response.data.message;
        } finally {
            setTimeout(() => setSavingNewEquipment(false), 600);
        }
    };

    return { saveNewEquipment, savingNewEquipment };
};
